export const ORGANIZE_MARKETPLACE_NAV_KEY_LIST: ReadonlyArray<string> = [
    'catalogue',
    'customers',
    'settings',
];

export const ORGANIZE_CERTIFICATES_NAV_KEY_LIST: ReadonlyArray<string> = [
    'certificate',
    'transactions',
];